import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import {
  Briefcase,
  FileText,
  Users,
  Building2,
  Activity,
  Heart,
} from "lucide-react";
import BgImage from "../../assets/photo_2026-03-28_11-24-44.jpg";

const items = [
  {
    icon: Briefcase,
    title: "Litigation & Arbitration",
    detail:
      "Legal representation in civil, criminal, and commercial disputes, including mediation and arbitration proceedings.",
  },
  {
    icon: FileText,
    title: "Employment & Labour",
    detail:
      "Advising employers on labour laws, workplace policies, employee relations, contracts, compliance, and dispute resolution.",
  },
  {
    icon: Users,
    title: "Tax",
    detail:
      "Advisory on tax compliance, regulations, planning strategies, and resolving tax disputes with authorities.",
  },
  {
    icon: Building2,
    title: "Real Estate & Construction",
    detail:
      "Legal support for property transactions, construction agreements, land use, development projects, and dispute management.",
  },
  {
    icon: Activity,
    title: "Investment, Trade & Regulatory Affairs",
    detail:
      "Guidance on business licensing, trade regulations, foreign investment compliance, customs procedures, and regulatory requirements.",
  },
  {
    icon: Heart,
    title: "Banking, Finance & Capital Markets",
    detail:
      "Advisory on banking regulations, financial transactions, lending agreements, capital markets compliance, and finance disputes.",
  },
];

export default function AreasOfPractice() {
  const ref = useRef(null);

  // Parallax scroll effect
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start end", "end start"],
  });

  const y = useTransform(scrollYProgress, [0, 1], ["0%", "-20%"]);

  return (
    <div
      ref={ref}
      className="relative w-full min-h-screen overflow-hidden text-white"
    >
      {/* Parallax Background */}
      <motion.div style={{ y }} className="absolute inset-0">
        <div
          className="w-full h-[120%] bg-cover bg-center"
          style={{
            backgroundImage: `url(${BgImage})`,
          }}
        />
      </motion.div>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/75" />

      {/* Content */}
      <div className="relative z-10 max-w-6xl mx-auto px-6 py-24 text-center">
        <h2 className="text-4xl md:text-5xl font-serif tracking-wide mb-4">
          Areas of Practice
        </h2>

        <p className="text-gray-300 max-w-2xl mx-auto mb-14 text-sm leading-relaxed font-light">
          Our Office has been supporting this legal aid program for three years.
          The transparency and impact reports show exactly how our services make
          a difference in the community.
        </p>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-y-14 gap-x-10">
          {items.map((item, i) => {
            const Icon = item.icon;
            return (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ delay: i * 0.15, duration: 0.6 }}
                viewport={{ once: true }}
                className="group"
              >
                <div className="flex flex-col items-center space-y-4">
                  <Icon className="w-10 h-10 text-gray-300 group-hover:text-white transition duration-300" />

                  <h3 className="text-lg font-serif tracking-wide">
                    {item.title}
                  </h3>

                  <p className="text-gray-400 text-sm max-w-xs leading-relaxed">
                    {item.detail}
                  </p>

                  <span className="text-xs tracking-[0.2em] text-gray-400 border-b border-gray-500 pb-1 cursor-pointer hover:text-white transition duration-300">
                    <a href="/services"> MORE DETAILS </a>
                  </span>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
